import styled from 'styled-components';
import Vender from './assets/vender.svg';
import { useScreenQuery } from 'playup-web-core';
import React from 'react';

const amountOptions = [10, 25, 50, 100, 500];

const CreditCardInput = ({ amount, onAmountChange, error }) => {
	const { isSmall } = useScreenQuery();
	const onAddAmountButtonPress = React.useCallback(
		(value) => {
			if (isNaN(parseFloat(amount))) {
				onAmountChange(parseFloat(value).toFixed(2));
				return;
			}
			onAmountChange((parseFloat(amount) + parseFloat(value)).toFixed(2));
			return;
		},
		[amount, onAmountChange]
	);
	return (
		<Container>
			<ProviderImageGroup>
				<ProviderImage isSmallScreen={isSmall} src={Vender} alt={'Vender'} />
				Debit Card
			</ProviderImageGroup>
			Deposit Amount
			<InputContainer error={!!error}>
				$ <Input value={amount} onChange={(e) => onAmountChange(e.target.value)} />
			</InputContainer>
			<ErrorText>{error?.message}</ErrorText>
			<AmountButtonGroup>
				{amountOptions.map((item) => {
					return (
						<AmountButton key={item.toString()} onClick={() => onAddAmountButtonPress(item)}>
							+${item}
						</AmountButton>
					);
				})}
			</AmountButtonGroup>
		</Container>
	);
};
const AmountButtonGroup = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	width: 100%;
`;
const AmountButton = styled.div`
	background-color: #fff;
	height: 30px;
	width: calc(20% - 6px);
	justify-content: center;
	align-items: center;
	display: flex;
	border-radius: 6px;
	cursor: pointer;
`;
const ErrorText = styled.span`
	color: red;
	margin-bottom: 5px;
`;
const ProviderImage = styled.img<{ isSmallScreen: boolean; isWhiteColor?: boolean }>(
	({ isSmallScreen, isWhiteColor }) => ({
		height: isSmallScreen ? '36px' : '48px',
		filter: isWhiteColor ? 'invert(100%)' : 'none',
		marginRight: '20px',
	})
);
const Input = styled.input`
	width: 100%;
	height: 100%;
`;
const InputContainer = styled.div<{ error: boolean }>`
	background-color: #fff;
	height: 40px;
	width: 100%;
	margin-top: 7px;
	margin-bottom: 7px;
	border-radius: 6px;
	align-items: center;
	justify-content: start;
	display: flex;
	padding-left: 10px;
	padding-right: 10px;
	border: ${({ error }) => (error ? '1px solid red' : 'none')};
`;
const Container = styled.div`
	background-color: #dde1e3;
	padding: 13px;
	border-radius: 6px;
	display: flex;
	align-items: start;
	flex-direction: column;
	font-size: 12px;
	font-weight: 600;
`;
const ProviderImageGroup = styled.div({
	display: 'flex',
	flexDirection: 'row',
	flexWrap: 'wrap',
	alignItems: 'center',
	justifyContent: 'center',
	fontSize: '12px',
	fontWeight: '600',
	marginBottom: '10px',
});
export default CreditCardInput;
